export const boxStyle = {
  width: '100%',
  height: 160,
  maxHeight: 175,
  border: 'solid 1px #eaf0fd',
  borderRadius: 17,
};
